import { useFormatting } from "@msys/ui";
import type { GridColDef } from "@mui/x-data-grid-premium";
import type { EstimatedCalculation__ItemFragment } from "../../doc-items/boxes/EstimatedCalculationBox.generated.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
}

function PriceSubTotalCell({ value }: { value: number }) {
  const { getFormattedPrice } = useFormatting();
  return (
    <span style={{ fontWeight: value > 0 ? "bold" : "normal" }}>
      {getFormattedPrice(value)}
    </span>
  );
}

export function createPriceSubTotalColumn<
  T extends DocDataGrid_ItemFragment & EstimatedCalculation__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "priceSubTotal",
    headerName: options.headerName,
    width: 110,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (_value, row) =>
      row.item?.proposedCalculation?.priceSubTotal ?? 0,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      return <PriceSubTotalCell value={params.value ?? 0} />;
    },
  };
}
